export const FEATURE_FLAGS_DEFAULT_VALUES = {
	policies: false,
	'skip-default-billing-plan': false,
	'table-v2': true,
	'editor-ai-summary-block': false,
	'queries-v3': false,
	'region-selector': false,
	'data-quality-score-sla': false,
	'ai-personas': false,
	'monitor-creation-flow': false,
	'editor-refactor': false,
	'monitor-annotations': false,
	'monitor-models': false,
	'native-snowflake': false,
	'ai-new-architecture': false,
	'ai-impact-dashboard': false,
	'workspace-ai-feedback': false,
	'create-workspace': false,
	'query-block-scheduling': false,
	'activity-log-snapshot-merge': false,
	'car-gurus-activity-log-restore': false,
	'data-access-request': false,
	'allow-xai-llm': false,
	'ai-memory': false,
	'fe-activity-log': false,
	'entity-privileges-tab': false,
	'custom-properties-filter': false,
	'settings-nav': false,
	'report-cards-view': false,
	'monitor-show-query': false,
	'ai-question-workflow': false,
	'ask-ai-in-question': false,
	'ai-tokens': false,
	'allow-frequent-syncs': false,
	'teams-permissions-v2-frontend': false,
	'execute-access-v2': false,
	'user-level-credentials': true,
	'questions-overview': false,
	'monitor-import': false,
	'azure-data-lake-integration': false,
	'policy-v2': false,
	'dqs-v2': false,
	'git-agent': false,
	'servicenow-integration': false,
	'ai-suggestions-enabled': false,
	'monitor-notification-rules': false,
	'secoda-lite-onboarding': false,
	'disable-ai-assistant-status-banner': false,
	'automation-ai-generation': false,
	'secoda-new-plan-billing': false,
	'secoda-ai-tasks': false,
	'extensions-in-integrations-page': false,
	'verifiable-queries': false,
	'lineage-lazy-load': false,
	'onboarding-skip-payment': false,
	'onboarding-skip-integrations': false,
	'custom-llm-provider': false,
	'micro-strategy-one-integration': true,
	'bi-dashboards-enabled': true,
	'servicenow-access-request-form': false,
	'data-scanning': false,
	'strict-run-sql-permissions': false,
	'custom-properties-ui-update': false,
	'ai-analytics-email': false,
	'legacy-git-integration': false,
	'jsm-help-menu': false,
} as const;
